<template>
    <div>
    </div>
</template>

<script>
export default {
    created() {
        this.getVolunteerInfo();
    },
    computed: {
        volunteerData() {
            return this.$store.getters['volunteer/getVolunteerData'];
        },
        currentUserID() {
            return this.$store.getters['user/getCurrentUserID'];
        },
        currentFDID() {
            return this.$store.getters['fd/getCurrentFDID'];
        }
    },
    methods: {
        async getVolunteerInfo() {
            console.log("Load volunteer data for user: " + this.currentUserID, " and FD: " + this.currentFDID);
            this.isLoading = true;
            try {
                await this.$store.dispatch('volunteer/loadVolunteerData', {
                    userID: this.currentUserID,
                    fdID: this.currentFDID
                });
            } catch (error) {
                this.error = error.message || 'Something went wrong!';
            }
            this.isLoading = false;
        }
    },
    unmounted() {
        this.$store.dispatch('volunteer/unsubscribeVolunteer')
    }
}
</script>